import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoAccessGranted: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.market_pulse) {
    return true;
  } else {
    return { name: 'home' };
  }
};
